'use client'
import { SliderNavigation } from '@/components/SliderNavigation'
import { Image, InfoCard } from '@/services/Api/generated'
import cn from 'classnames'
import { FunctionComponent } from 'react'
import 'swiper/css'
import 'swiper/css/free-mode'
import { FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { AdvantageCard } from '../AdvantageCard'
import styles from './Advantages.module.scss'
import { IconName } from '@/icons'

type AdvantagesProps = {
  className?: string
  list: { title: string; description: string; icon: Image | IconName }[]
}
export const Advantages: FunctionComponent<AdvantagesProps> = ({
  className,
  list,
}) => {
  return (
    <div className={cn(className, styles.container)}>
      <Swiper
        spaceBetween={12}
        slidesPerView={'auto'}
        modules={[FreeMode]}
        freeMode={true}
        className={styles.containerList}
        wrapperClass={styles.list}
        breakpoints={{
          768: {
            spaceBetween: 20,
            slidesOffsetAfter: 20,
            slidesOffsetBefore: 20,
          },
          1024: {
            enabled: false,
            spaceBetween: 0,
          },
        }}
      >
        {list.map((item) => (
          <SwiperSlide key={item.description} className={styles.card}>
            <AdvantageCard
              icon={item.icon}
              title={item.title}
              description={item.description}
            />
          </SwiperSlide>
        ))}
        <SliderNavigation className={styles.navigation} />
      </Swiper>
    </div>
  )
}
